import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

import LazyComponent from '../../components/asyncComponent';

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
				<article class="has-widget">
					<p>Viens balss kanāls un viens telefona numurs, kas tiek nodrošināts, izmantojot interneta pieslēgumu un <i>SIP (Session Initiation Protocol) pārraides protokolu</i>.</p>
					<h2>Priekšrocības</h2>
					<ul>
						<li>Iespēja izmantot tālruni jebkurā vietā, kur pieejams interneta pieslēgums. </li>
						<li>Iespēja ērti pārskatīt zvanu atskaites</li>
						<li>Tālruņa numurs, kuru viegli atcerēties - patreiz vēl pieejami numuri no DolphNet numuru diapazona - +371 69999 XXX, </li>
					</ul>
				</article>
				<div class="widget plan">
					<h3><span class="from"><Text id="cart.from"/></span><span class="value">€5</span><span class="term"> <Text id="cart.month.full"/></span></h3>
				     <ul class="bullet">
				     	<li>Bezmaksas ierīkošana</li>
				     	<li>Slēdzot līgumu uz 12 mēnešiem dāvanā IP telefona aparāts.</li>
				     </ul>
				     <div><Link href={store.prefix+'/contact?service=phone&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
				</div>
				<div class="clearfix"/>
				<article>
					<h2>Sarunu tarifi</h2>
					<LazyComponent getComponent={()=>import('./tariffs')}/>
				</article>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/phone.js